import React from 'react';
import { connect } from 'react-redux';

import Page from '../../../page.jsx';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import partnerPropTypes from '../../../partnerPropTypes.js';
import ReceiptLink from '../../../receiptLink.jsx';
import FeedbackLink, { BUYER_HAPPY } from '../../../feedbackLink.jsx';

const ItemApprovedDetails = ({ partner, payment }) => (
    <Page heading="Gratulerer, dere er ferdige med handelen!">
        <div>
            <p className="r-ptl">
                Vi overfører nå din betaling til {partner.name}.
            </p>
            <div className="r-phl">
                <ReceiptLink payment={payment} />
                <FeedbackLink type={BUYER_HAPPY} />
            </div>
        </div>
    </Page>
);

ItemApprovedDetails.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        partner: state.partner,
        payment: state.payment.data,
    };
}

export default connect(mapStateToProps)(ItemApprovedDetails);



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/statusDetails/itemApprovedDetails.jsx